<template>
    <div class="messages-content">
        <SectionContainer
            title="Histórico de Mensagens"
            icon="comments"
        >
            <!-- Chat container -->
            <div class="chat-container">
                <div class="chat-messages" id="chat" ref="scrollContainer">
                    <div v-if="notifications.length > 0" class="messages-list">
                        <div
                            v-for="(notification, index) in notifications"
                            :key="'notification' + notification.id"
                            class="message-wrapper"
                        >
                            <!-- Separador de data -->
                            <div class="row" v-if="verifyDates(index)">
                                <div class="col text-center my-3">
                                    <div class="date-separator">
                                        <i class="fas fa-calendar-alt"></i>
                                        {{ getDate(index) }}
                                    </div>
                                </div>
                            </div>

                            <!-- Mensagem -->
                            <div class="row message-row">
                                <div class="col">
                                    <div
                                        class="message-bubble"
                                        :class="{
                                            'message-sent': notification.target === 1,
                                            'message-received': notification.target === 0
                                        }"
                                    >
                                        <div class="message-content">
                                            {{ notification.description }}
                                        </div>

                                        <div class="message-footer">
                                            <span class="message-time">
                                                <i class="fas fa-clock"></i>
                                                {{ formatHour(notification.date_notification) }}
                                            </span>

                                            <div
                                                v-if="notification.target === 1"
                                                class="message-status"
                                            >
                                                <i
                                                    class="fas fa-check-circle"
                                                    :class="{
                                                        'text-success': notification.status === 1,
                                                        'text-muted': notification.status === 0
                                                    }"
                                                    :title="notification.status === 1 ? 'Lida' : 'Enviada'"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Estado vazio -->
                    <div v-else class="empty-messages">
                        <div class="empty-icon">
                            <i class="fas fa-comments"></i>
                        </div>
                        <div class="empty-title">Nenhuma mensagem</div>
                        <div class="empty-subtitle">
                            Comece uma conversa enviando a primeira mensagem.
                        </div>
                    </div>
                </div>

                <!-- Formulário de nova mensagem -->
                <div class="message-input-container">
                    <form @submit.prevent="newMessage" class="message-form">
                        <div class="input-group">
                            <input
                                v-model="description"
                                type="text"
                                class="form-control message-input"
                                placeholder="Digite sua mensagem..."
                                :disabled="isLoading"
                            />
                            <div class="input-group-append">
                                <button
                                    class="btn-primary send-button"
                                    type="submit"
                                    :disabled="!description.trim() || isLoading"
                                    id="submitMessage"
                                >
                                    <i class="fas fa-paper-plane"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </SectionContainer>
    </div>
</template>

<script>
import SectionContainer from "../../Modals/Checklist/SectionContainer.vue";

export default {
    components: {
        SectionContainer
    },
    props: {
        reserve: { // reserve - dados da reserva para envio de mensagens
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            notifications: [], // notifications - lista de mensagens/notificações
            description: '', // description - texto da nova mensagem
            isLoading: false, // isLoading - estado de carregamento ao enviar mensagem
            intervalId: null, // intervalId - ID do intervalo para atualização automática
            observer: null // observer - IntersectionObserver para marcar como lida
        };
    },
    methods: {
        newMessage() { // newMessage - envia nova mensagem
            let id = this.$route.params.id;

            if (this.description.trim() === '') {
                return;
            }

            this.isLoading = true;

            const formData = {
                reserve_id: id,
                message: this.description,
                user_id: this.reserve.user_id,
            };

            const date = new Date();

            // Adiciona mensagem otimista na interface
            const newMessage = {
                "id": new Date().getTime(),
                "user_id": this.reserve.user_id,
                reserve_id: id,
                "description": this.description,
                "status": 0,
                "created_at": `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${date.getHours()}:${date.getMinutes()}:00.000000`,
                "date_notification": `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`,
                "target": 1
            };

            this.notifications.push(newMessage);
            this.description = '';

            const api = this.$store.state.api + "reserveVehicle/notifications";

            this.$http.post(api, formData)
                .then(() => {
                    // Sucesso - a mensagem otimista já foi adicionada
                })
                .catch(() => {
                    // Remove mensagem otimista em caso de erro
                    this.notifications.pop();
                    this.$message(null, 'Erro ao enviar mensagem!', "error");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatHour(dateTime) { // formatHour - formata hora da mensagem
            if (!dateTime) return '';
            let arr = dateTime.split(' ');
            return String(arr[1]).substring(0, 5);
        },
        getDate(index) { // getDate - obtém data formatada para separador
            const data = this.notifications[index];
            let today = new Date();
            let date2 = '';
            let date1 = '';
            const before = this.notifications[index - 1];

            if (index === 0) {
                date2 = new Date(data.created_at);
            } else {
                date1 = new Date(before.created_at);
                date2 = new Date(data.created_at);
                if (this.isSameDay(date2, date1)) return;
            }

            if (this.isSameDay(date2, today)) {
                return 'Hoje';
            } else if (this.isSameOneDay(date2, today)) {
                return 'Ontem';
            } else if ((today - date2) / (1000 * 60 * 60 * 24) < 7) {
                const daysOfWeek = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
                return daysOfWeek[date2.getDay()];
            } else {
                let arr = data.date_notification.split(' ');
                return arr[0];
            }
        },
        verifyDates(index) { // verifyDates - verifica se deve exibir separador de data
            if (index === 0) {
                return true;
            } else {
                const before = this.notifications[index - 1];
                const data = this.notifications[index];
                const date1 = new Date(before.created_at);
                const date2 = new Date(data.created_at);
                return !this.isSameDay(date2, date1);
            }
        },
        isSameDay(date1, date2) { // isSameDay - verifica se duas datas são do mesmo dia
            return date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate();
        },
        isSameOneDay(date1, date2) { // isSameOneDay - verifica se é um dia anterior
            return date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate() - 1;
        },
        getNotifications() { // getNotifications - busca mensagens da API
            let self = this;
            let id = self.$route.params.id;
            let api = self.$store.state.api + "notifications/?paginated=false&type_notification=3&reserve_id=" + id + "&with[]=reserve_status";

            self.$http
                .get(api)
                .then((response) => {
                    self.notifications = response.data.data;
                    this.read();
                })
                .catch((error) => {
                    console.error("Erro ao buscar notificações:", error);
                });
        },
        scrollToBottom() { // scrollToBottom - faz scroll para última mensagem
            this.$nextTick(() => {
                const container = this.$refs.scrollContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },
        myObserver() { // myObserver - configura observer para marcar mensagens como lidas
            const element = document.getElementById('submitMessage');
            if (element) {
                const options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 1.0
                };

                this.observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.read();
                        }
                    });
                }, options);

                this.observer.observe(element);
            }
        },
        read() { // read - marca mensagens como lidas
            let self = this;
            let id = self.$route.params.id;
            let api = self.$store.state.api + "notifications/readAll";
            const formData = {
                reserve_id: id,
                target: 0
            };

            self.$http
                .post(api, formData)
                .catch(() => {
                    console.error('Erro ao marcar mensagens como lidas');
                });
        },
    },
    mounted() {
        this.getNotifications();
        this.intervalId = setInterval(this.getNotifications, 15000);
        this.scrollToBottom();
        this.myObserver();
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    watch: {
        notifications: {
            handler() {
                this.scrollToBottom();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.messages-content {
    padding: 20px;
    background-color: white;
}

/* Container do chat */
.chat-container {
    background-color: #f8f9fa;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.chat-messages {
    max-height: 500px;
    overflow-y: auto;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.messages-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Separador de data */
.date-separator {
    background: linear-gradient(90deg, #f8981d, #fd7e14);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 2px 4px rgba(248, 152, 29, 0.3);
}

/* Mensagens */
.message-row {
    margin-bottom: 8px;
}

.message-bubble {
    max-width: 75%;
    padding: 12px 16px;
    border-radius: 18px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.message-bubble:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Mensagem enviada (usuário admin) */
.message-sent {
    background: linear-gradient(135deg, #FE8D18, #0056b3);
    color: white;
    margin-left: auto;
    border-bottom-right-radius: 6px;
}

/* Mensagem recebida (usuário da reserva) */
.message-received {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
    margin-right: auto;
    border-bottom-left-radius: 6px;
}

.message-content {
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: 6px;
    word-wrap: break-word;
}

.message-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    opacity: 0.8;
}

.message-time {
    display: flex;
    align-items: center;
    gap: 4px;
}

.message-status {
    margin-left: 8px;
}

/* Estado vazio */
.empty-messages {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.empty-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #e9ecef, #f8f9fa);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 2rem;
    color: #6c757d;
}

.empty-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
}

.empty-subtitle {
    color: #6c757d;
    font-size: 1rem;
}

/* Formulário de input */
.message-input-container {
    padding: 20px;
    background-color: white;
    border-top: 1px solid #e2e8f0;
}

.message-form {
    width: 100%;
}

.input-group {
    display: flex;
    width: 100%;
}

.message-input {
    border: 2px solid #e2e8f0;
    border-radius: 25px 0 0 25px;
    padding: 12px 20px;
    font-size: 14px;
    transition: all 0.3s ease;
    border-right: none;
}

.message-input:focus {
    border-color: #f8981d;
    box-shadow: 0 0 0 3px rgba(248, 152, 29, 0.1);
    outline: none;
}

.send-button {
    background: linear-gradient(135deg, #f8981d, #fd7e14);
    border: 2px solid #f8981d;
    border-radius: 0 25px 25px 0;
    padding: 12px 20px;
    color: white;
    font-weight: 600;
    transition: all 0.3s ease;
    border-left: none;
    min-width: 60px;
    height: 40px;
}

.send-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #fd7e14, #f8981d);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(248, 152, 29, 0.4);
}

.send-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Ações */
.actions-container {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e2e8f0;
    text-align: center;
}

/* Scrollbar customizada */
.chat-messages::-webkit-scrollbar {
    width: 6px;
}

.chat-messages::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb {
    background: rgba(248, 152, 29, 0.3);
    border-radius: 3px;
    transition: all 0.3s ease;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
    background: rgba(248, 152, 29, 0.6);
}

/* Responsividade */
@media (max-width: 768px) {
    .messages-content {
        padding: 15px;
    }

    .chat-messages {
        max-height: 400px;
        padding: 15px;
    }

    .message-bubble {
        max-width: 85%;
        padding: 10px 14px;
    }

    .message-content {
        font-size: 13px;
    }

    .date-separator {
        font-size: 11px;
        padding: 6px 12px;
    }

    .message-input-container {
        padding: 15px;
    }

    .message-input {
        padding: 10px 16px;
        font-size: 13px;
    }

    .send-button {
        padding: 10px 16px;
        min-width: 50px;
    }
}

@media (max-width: 576px) {
    .chat-messages {
        max-height: 350px;
        padding: 10px;
    }

    .message-bubble {
        max-width: 90%;
        padding: 8px 12px;
    }

    .message-content {
        font-size: 12px;
    }

    .message-footer {
        font-size: 10px;
    }

    .empty-icon {
        width: 60px;
        height: 60px;
        font-size: 1.5rem;
    }

    .empty-title {
        font-size: 1.1rem;
    }

    .empty-subtitle {
        font-size: 0.9rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/view-components/ViewMessages.vue